import {EReportsInsightsActions, ReportsInsightsActions} from "../../actions/reports/insights.actions";
import {
  initialReportAvgPriceState,
  initialReportBestItemsState,
  initialReportFillRateState,
  initialReportKeyIndicatorsState,
  initialReportKeyIndicatorsSuppliersState,
  initialReportMarketShareState,
  initialReportProfitabilityState, initialReportPromoState, initialReportServiceLevelState,
  initialReportStockRotationState, IReportAvgPriceState,
  IReportBestItemsState,
  IReportFillRateState,
  IReportKeyIndicatorsState,
  IReportKeyIndicatorsSuppliersState,
  IReportMarketShareState,
  IReportProfitabilityState, IReportPromoState, IReportServiceLevelState,
  IReportStockRotationState
} from "../../state/reports/reports-insights.state";



//редьюсеры отчета fill rate
export const reportInsightsFillRateReducers = (
  state = initialReportFillRateState,
    action: ReportsInsightsActions
):IReportFillRateState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetFillRate: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetFillRateSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetFillRateFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};

export const reportInsightsStockRotationReducers = (
  state = initialReportStockRotationState,
  action: ReportsInsightsActions
):IReportStockRotationState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetStockRotation: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetStockRotationSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetStockRotationFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};

export const reportInsightsMarketShareReducers = (
  state = initialReportMarketShareState,
  action: ReportsInsightsActions
):IReportMarketShareState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetMarketShare: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetMarketShareSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetMarketShareFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};

export const reportInsightsKeyIndicatorsReducers = (
  state = initialReportKeyIndicatorsState,
  action: ReportsInsightsActions
):IReportKeyIndicatorsState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetKeyIndicators: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetKeyIndicatorsSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetKeyIndicatorsFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};


export const reportInsightsProfitabilityReducers = (
  state = initialReportProfitabilityState,
  action: ReportsInsightsActions
):IReportProfitabilityState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetProfitability: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetProfitabilitySuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetProfitabilityFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};

export const reportInsightsPromoReducers = (
  state = initialReportPromoState,
  action: ReportsInsightsActions
):IReportPromoState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetPromo: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetPromoSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetPromoFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};
export const reportInsightsKeyIndicatorsSupplierReducers = (
  state = initialReportKeyIndicatorsSuppliersState,
  action: ReportsInsightsActions
):IReportKeyIndicatorsSuppliersState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetKeyIndicatorsSuppliers: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetKeyIndicatorsSuppliersSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetKeyIndicatorsSuppliersFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};
export const reportInsightsBestItemsReducers = (
  state = initialReportBestItemsState,
  action: ReportsInsightsActions
):IReportBestItemsState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetBestItems: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetBestItemsSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetBestItemsFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};
export const reportInsightsAvgPriceReducers = (
  state = initialReportAvgPriceState,
  action: ReportsInsightsActions
):IReportAvgPriceState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetAvgPrice: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetAvgPriceSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetAvgPriceFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};

export const reportInsightsServiceLevelReducers = (
  state = initialReportServiceLevelState,
  action: ReportsInsightsActions
):IReportServiceLevelState =>{
  switch (action.type) {
    case EReportsInsightsActions.GetServiceLevel: {
      return {
        ...state
      };
    }
    case EReportsInsightsActions.GetServiceLevelSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsInsightsActions.GetServiceLevelFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false

      };
    }
    default:
      return state;
  }
};
